export default "__VITE_ASSET__CP_X1pfq__"